import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedGuard } from './auth/guards/authenticated.guard';
import { ContentComponent } from './core/components/content/content.component';
import { NoMaintenanceGuard } from './core/guards/no-maintenance.guard';
import { CustomerResolver } from './core/resolvers/customer.resolver';
import { liabilitiesRoutes } from './liabilities/liabilities-routing.module';
import { ErrorStatusComponent } from './shared/components/error-status/error-status.component';

export const routes: Routes = [
  {
    canActivate: [NoMaintenanceGuard, AuthenticatedGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
        path: 'admin',
      },
      ...liabilitiesRoutes,
      {
        loadChildren: () => import('./billers/billers.module').then((m) => m.BillersModule),
        path: 'billers',
      },
      {
        loadChildren: () => import('./credit-card/credit-card.module').then((m) => m.CreditCardModule),
        path: 'creditCards',
      },
      {
        loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
        path: 'dashboard',
      },
      {
        loadChildren: () => import('./defer/deferred-payments.module').then((m) => m.DeferredPaymentsModule),
        path: 'deferred-payments',
      },
      {
        loadChildren: () => import('./email-account/email-account.module').then((m) => m.EmailAccountModule),
        path: 'email',
      },
      {
        loadChildren: () =>
          import('./promotion-coupons/promotion-coupons.module').then((m) => m.PromotionCouponsModule),
        path: 'promotion-coupons',
      },
      {
        loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
        path: 'settings',
      },
      {
        loadChildren: () => import('./offers/offers.module').then((m) => m.OffersModule),
        path: 'offers',
      },
      {
        loadChildren: () => import('./account-consents/account-consents.module').then((m) => m.AccountConsentsModule),
        path: 'consents',
      },
      {
        loadChildren: () => import('./account/account.module').then((m) => m.AccountModule),
        path: 'account',
      },
      {
        loadChildren: () => import('./banners/banners.module').then((m) => m.BannersModule),
        path: 'banners',
      },
      {
        component: ErrorStatusComponent,
        data: {
          toolbar: {
            title: 'Coś poszło nie tak...',
          },
        },
        path: 'error/:status',
      },
    ],
    component: ContentComponent,
    path: '',
    resolve: {
      customer: CustomerResolver,
    },
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    paramsInheritanceStrategy: 'always'

  })],
})
export class AppRoutingModule {}
